import React, { useEffect } from "react";
import { Link } from "react-router";
import gsap, { Power3 } from "gsap";
import Scrollbar from "smooth-scrollbar";
const Overlaymenu = () => {
  useEffect(() => {
    let scrollbar;
    let headerAnimation;

    const initializeHeader = () => {
      const overlayMenu = document.querySelector(".overlay-menu");
      const burgerMenu = document.querySelectorAll("header .burger-menu"); // More specific selector
      const anchorinoverlay = document.querySelectorAll(
        ".overlay-menu nav ul li a"
      );
      const closeButton = document.querySelector(".overlay-menu .close");
      const fixedElement = document.getElementById("fixed");

      if (!overlayMenu || !burgerMenu || !closeButton) {
        console.warn(
          "Required elements for header animation not found in the DOM."
        );
        return; // Exit early if elements are missing
      }

      headerAnimation = gsap.timeline({ yoyo: false, reversed: true });
      headerAnimation.pause();

      headerAnimation.from(overlayMenu, { autoAlpha: 0 });
      headerAnimation.from(
        overlayMenu.querySelector(".left-area"),
        { y: "100vh" },
        0.1
      );
      headerAnimation.from(
        overlayMenu.querySelector(".right-area"),
        { y: "-100vh" },
        0.1
      );
      headerAnimation.from(
        overlayMenu.querySelector(".right-area ul"),
        { autoAlpha: 0, stagger: 0.1 },
        0.5
      );
      headerAnimation.from(
        overlayMenu.querySelectorAll(
          "nav li:not(.overlay-menu nav ul li ul li)"
        ),
        { stagger: 0.1, y: 30, autoAlpha: 0, ease: "Expo.easeInOut" },
        0.5
      );
      headerAnimation.from(
        overlayMenu.querySelectorAll(
          "nav li:not(.overlay-menu nav ul li ul li)"
        ),
        { clearProps: "all", delay: 1.3, ease: "Expo.easeInOut" },
        0.5
      );

      const toggleHeaderAnimation = () =>
        headerAnimation.reversed()
          ? headerAnimation.play()
          : headerAnimation.reverse();
      burgerMenu.forEach((element) => {
        element.addEventListener("click", toggleHeaderAnimation);
      });
      anchorinoverlay.forEach((element) => {
        element.addEventListener("click", toggleHeaderAnimation);
      });

      // burgerMenu.addEventListener('click', toggleHeaderAnimation);
      closeButton.addEventListener("click", toggleHeaderAnimation);

      overlayMenu
        .querySelectorAll(".menu-item-has-children")
        .forEach((menuItem) => {
          const menuItemAnimation = gsap.timeline({
            yoyo: false,
            reversed: true,
          });
          menuItemAnimation.pause();

          menuItemAnimation.to(menuItem.querySelectorAll("li a"), {
            stagger: 0.1,
            autoAlpha: 0,
            y: -50,
            pointerEvents: "none",
            ease: Power3.easeOut,
          });
          menuItemAnimation.to(menuItem.querySelector("ul"), {
            zIndex: "10",
            pointerEvents: "all",
          });
          menuItemAnimation.from(
            menuItem.querySelector("ul").querySelectorAll("li a"),
            { stagger: 0.1, autoAlpha: 0, y: 30, ease: Power3.easeOut }
          );

          menuItem
            .querySelector(".back")
            ?.addEventListener("click", () => menuItemAnimation.reverse());
          menuItem
            .querySelector("a")
            ?.addEventListener("click", () =>
              menuItemAnimation.reversed()
                ? menuItemAnimation.play()
                : menuItemAnimation.reverse()
            );
        });

      if (fixedElement) {
        const handleScroll = ({ offset }) => {
          fixedElement.style.top = `${offset.y + window.innerHeight - 90}px`;
        };
        scrollbar = Scrollbar.init(document.body);
        scrollbar.addListener(handleScroll);
        return () => {
          scrollbar.removeListener(handleScroll);
          scrollbar.destroy();
        };
      }

      return () => {
        burgerMenu.removeEventListener("click", toggleHeaderAnimation);
        closeButton.removeEventListener("click", toggleHeaderAnimation);
        if (scrollbar) {
          scrollbar.destroy();
        }
        if (headerAnimation) {
          headerAnimation.kill();
        }
      };
    };

    if (document.readyState === "complete") {
      initializeHeader();
    } else {
      window.addEventListener("load", initializeHeader);
      return () => window.removeEventListener("load", initializeHeader);
    }
  }, []);

  return (
    <>
      <div className="overlay-menu">
        <div className="close">
          <div className="xb-close"></div>
        </div>
        <div className="row overlay-wrap">
          <div className="col-xl-8 col-md-7 left-area">
            <nav>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <Link to="/blogs">Blogs</Link>
                </li>
                <li>
                  <Link to="/services">Services</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </nav>
          </div>
          <div className="col-xl-4 col-md-5 right-area">
            <ul>
              <li>
                <span className="title">Brief us</span>
              </li>
              <li>
                <a href="mailto:omsoftwareandtechnologies@gmail.com">
                  omsoftwareandtechnologies@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:+916239862469">+91 62398-62469</a>
              </li>
            </ul>

            <ul>
              <li>
                <span className="title">Follow us</span>
              </li>
              <li>
                <ul className="social-links">
                  <li>
                    <a
                      href="https://www.facebook.com/omsoftwares1"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/omsoftwares.in/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Instagram
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/omsoftwares1/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      LinkedIn 
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Overlaymenu;
